import { type DependencyList, useLayoutEffect } from "react";

interface UseResizeObserverOptions {
  additionalDependencies?: DependencyList;
  includeChildren?: boolean;
}

export const useResizeObserver = (element: HTMLElement | null, onResize: () => void, options?: UseResizeObserverOptions) => {
  const { additionalDependencies = [], includeChildren = false } = options ?? {};

  useLayoutEffect(() => {
    let frameId = 0;

    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(frameId);
        frameId = window.requestAnimationFrame(() => onResize());
      });

      const observedElements = [element, ...(includeChildren ? element.children : [])].filter((element) => element instanceof Element);
      for (const element of observedElements) {
        resizeObserver.observe(element);
      }

      return () => {
        window.cancelAnimationFrame(frameId);
        for (const element of observedElements) {
          resizeObserver.unobserve(element);
        }
      };
    }
  }, [element, onResize, includeChildren, ...additionalDependencies]);
};
